






































































import Vue from 'vue';
import { Component } from 'vue-property-decorator';
// import CustomFilepond from '@shared/components/forms/inputs/filepond/custom-filepond.vue';

@Component({
  name: 'bpc-import-tenant-data',
  components: {
    // 'bpc-filepond': CustomFilepond,
  },
})
export default class ImportTenantData extends Vue {
  loading = false;

  output = '';
  folderTree = '';
  error = null;
  file = null;
  /* Lifecycle hooks */
  // created () { }
  mounted() {
    this.showFolderTree();
  }
  // updated () { }
  // destroyed () { }

  get tenantId(): number {
    return this.$store.getters['tenant/selectedTenantId'];
  }

  async uploadFile() {
    this.loading = true;
    const basePath = this.$bpcApiRouteHelper.getEntityPath('superadmin-options');
    const path = `${basePath}/${this.tenantId}/process-import/upload-file`;

    const formData = new FormData();
    formData.append('importFile', this.file);

    try {
      const res = await this.$bpcApi.postWithMedia(path, formData).toPromise();
      this.folderTree = res.data.folderTree;
      this.loading = false;
    } catch (error) {
      console.log(error);
      const message =
        error?.response?.data?.message || 'core.superadmin_options_error_uploading_file';
      this.$bpcMessage.showErrorMessage({
        text: message,
      });

      this.loading = false;
    }

    await this.showFolderTree();
  }

  async processImports() {
    this.loading = true;
    const basePath = this.$bpcApiRouteHelper.getEntityPath('superadmin-options');
    const path = `${basePath}/${this.tenantId}/process-import`;

    try {
      const res = await this.$bpcApi.post(path).toPromise();
      this.folderTree = res.data.folderTree;
      this.output = res.data.output;
      this.error = res.data.error;
      this.loading = false;
    } catch (error) {
      console.log(error);
      this.$bpcMessage.showErrorMessage({
        text: 'core.superadmin_options_error_importing_csv',
      });
      this.loading = false;
    }
  }

  async showFolderTree() {
    this.loading = true;
    const basePath = this.$bpcApiRouteHelper.getEntityPath('superadmin-options');
    const path = `${basePath}/${this.tenantId}/process-import/folder-tree`;
    try {
      const res = await this.$bpcApi.get(path).toPromise();
      this.folderTree = res.data.folderTree;
    } catch (error) {
      console.log(error);
      this.$bpcMessage.showErrorMessage({
        text: 'core.superadmin_options_error_showing_folder_tree',
      });
    }
    this.loading = false;
  }
}
